import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["img1", "img2", "img3", "thumbnail", "properties"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import CdnPath from '../../utils/cdnPath';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '../../screens/index';
import ShopInterface from '../../api/ShopInterface';
import UpgradeType from '../../screens/UpgradeAccountFlow/UpgradeType';
import { casinoIdStatus as PlayerStatus } from '../../api/PlayerInfoConstants';
import { setOfferDetail as setOfferDetailAction, setRewardCenterCurrTab } from '../../state/actions/rewardCenter';
import { RewardCenterTabs } from '../../screens/RewardCenter/Constants';
import RewardCenterInterface from '../../api/RewardCenterInterface';
import store from '../../state/store';
import { isStar } from '../../utils/targetApplication';
import { setPurchaseType } from '../../state/actions/prePurchase';
import { setVipRoomUnlocked } from '../../state/actions/consumables';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import audio from '../../utils/audio';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import AppInterface from '../../api/AppInterface';
import { REG_EXP } from '../../constants';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var OfferDetail = /*#__PURE__*/function (_Component) {
  _inherits(OfferDetail, _Component);

  var _super = _createSuper(OfferDetail);

  function OfferDetail(props) {
    var _this;

    _classCallCheck(this, OfferDetail);

    _this = _super.call(this, props);
    _this.onPurchase = debounce( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(propertyId, shouldShowLinkAccountPopUp) {
        var TargetApp, _this$props, casinoIdStatus, casinoId, activeOffer;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(shouldShowLinkAccountPopUp && !isStar)) {
                  _context.next = 3;
                  break;
                }

                QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.LinkAccountForm));
                return _context.abrupt("return");

              case 3:
                audio.onClick();

                _this.setState({
                  purchaseDisabled: true
                });

                TargetApp = ENVIRONMENT_VARIABLES.APPLICATION_TARGET;
                _this$props = _this.props, casinoIdStatus = _this$props.casinoIdStatus, casinoId = _this$props.casinoId, activeOffer = _this$props.activeOffer;
                _context.t0 = TargetApp;
                _context.next = _context.t0 === 'star' ? 10 : 12;
                break;

              case 10:
                if (casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED || casinoIdStatus === PlayerStatus.DIGITALLY_VERIFIED) {
                  _this._purchaseReward(propertyId);

                  if (activeOffer.rewardtype === 'vip_room_access') {
                    store.dispatch(setPurchaseType(activeOffer.rewardtype));
                    store.dispatch(setVipRoomUnlocked(true));
                  } else {
                    store.dispatch(setPurchaseType(''));
                  }
                } else if (!casinoId) {
                  if (activeOffer.rewardtype === 'coins' || activeOffer.rewardtype === 'vip_room_access') {
                    store.dispatch(setPurchaseType(activeOffer.rewardtype));

                    _this._purchaseReward(propertyId);
                  } else {
                    _this.setState({
                      showKycPopUp: true
                    });
                  }
                }

                return _context.abrupt("break", 14);

              case 12:
                _this._purchaseReward(propertyId);

                if (activeOffer.rewardtype === 'vip_room_access') {
                  store.dispatch(setPurchaseType(activeOffer.rewardtype));
                } else {
                  store.dispatch(setPurchaseType(''));
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), 300);

    _this.hideKycPopUp = function () {
      audio.onClick();

      _this.setState({
        showKycPopUp: false
      });

      return _this.state.showKycPopUp;
    };

    _this.onKycCheck = function () {
      audio.onClick();
      var kycResult = _this.props.kycResult;

      if (kycResult === 'Fail') {
        var _QueryParamsProxy$set2;

        QueryParamsProxy.setQueryParams((_QueryParamsProxy$set2 = {}, _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_MODAL, Screens.KYCLockout), _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_NAVIGATE_TO, undefined), _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_UPGRADE_TYPE, undefined), _QueryParamsProxy$set2));
      } else {
        var _queryParams;

        var queryParams = (_queryParams = {}, _defineProperty(_queryParams, RouteParamConstants.PARAM_MODAL, Screens.UpgradeAccountFlow), _defineProperty(_queryParams, RouteParamConstants.PARAM_NAVIGATE_TO, Screens.RewardCenter), _defineProperty(_queryParams, RouteParamConstants.PARAM_UPGRADE_TYPE, UpgradeType.COMBINED), _queryParams);
        QueryParamsProxy.setQueryParams(queryParams);
      }
    };

    _this.onDismissPurchaseResponse = function () {
      audio.onClick();

      _this.setState({
        purchaseResponse: null,
        purchaseDisabled: false
      });
    };

    _this.sendOfferRedeemedEvent = function (offerInfo) {
      var _store$getState = store.getState(),
          coin = _store$getState.coin,
          loyalty = _store$getState.loyalty,
          rewardCenter = _store$getState.rewardCenter;

      var coinAmount = parseInt(rewardCenter.api.offerDetails.amount);
      var loyaltyAmount = parseInt(offerInfo.lpts);
      var eventPayload = {
        loyalty_points_before: (parseInt(loyalty.value) + loyaltyAmount).toString(),
        loyalty_points: loyaltyAmount.toString(),
        name: offerInfo.rname,
        id: offerInfo.rid,
        reward_type: offerInfo.cat_name,
        coins: coinAmount.toString(),
        balance_before: (parseInt(coin.value) - coinAmount).toString(),
        prop_id: offerInfo.propertyId
      };
      Logger.sendEvent(EVENT_TYPES.OFFER_REDEEMED, eventPayload);
    };

    _this.disabledButtonClick = function (hasVIPPass) {
      audio.onClick();
      var memberLevels = ['Gold', 'Platinum', 'Diamond'];

      if (hasVIPPass || memberLevels.includes(_this.props.memberLevel)) {
        QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.VipAccessFlow));
      }
    };

    _this.state = {
      purchaseResponse: null,
      purchaseDisabled: false,
      isLoading: false,
      showKycPopUp: false
    };
    return _this;
  }

  _createClass(OfferDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // ensure the ui has empty values in case the user is view an offer after viewing a previous offer
      var setOfferDetail = this.props.setOfferDetail;
      setOfferDetail({
        img1: null,
        img2: null,
        img3: null,
        thumbnail: null,
        hasData: false
      });

      this._getRewardDetails();
    }
  }, {
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return AppInterface.updateAppEvents();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: "_purchaseReward",
    value: function () {
      var _purchaseReward2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(propertyId) {
        var activeOffer, purchaseResponse, responseType, message;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                activeOffer = this.props.activeOffer;
                _context3.next = 4;
                return RewardCenterInterface.purchaseOffer(activeOffer.rid, propertyId);

              case 4:
                purchaseResponse = _context3.sent;

                if (purchaseResponse.success) {
                  this.sendOfferRedeemedEvent(activeOffer);
                  ShopInterface.refreshActiveConsumables();
                }

                responseType = purchaseResponse.success ? 'success' : 'error';
                message = responseType === 'success' ? purchaseResponse.msg : purchaseResponse.error;
                this.setState({
                  purchaseResponse: {
                    type: responseType,
                    message: message
                  }
                });
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);
                console.error(_context3.t0);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 11]]);
      }));

      function _purchaseReward(_x3) {
        return _purchaseReward2.apply(this, arguments);
      }

      return _purchaseReward;
    }()
  }, {
    key: "_getRewardDetails",
    value: function () {
      var _getRewardDetails2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$props2, activeOffer, setOfferDetail, rewardCenterBaseUrl, rewardDetailsResponse, thumbnailUrls, _rewardDetailsRespons, img1, img2, img3, thumbnail, properties, additionalData, propertyList;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                audio.onClick();
                _context4.prev = 1;
                _this$props2 = this.props, activeOffer = _this$props2.activeOffer, setOfferDetail = _this$props2.setOfferDetail, rewardCenterBaseUrl = _this$props2.rewardCenterBaseUrl;
                this.setState({
                  isLoading: true
                });
                _context4.next = 6;
                return RewardCenterInterface.getRewardDetail(activeOffer.rid);

              case 6:
                rewardDetailsResponse = _context4.sent;

                if (!(rewardDetailsResponse.success === true)) {
                  _context4.next = 15;
                  break;
                }

                thumbnailUrls = "".concat(CdnPath.REWARD_CENTER_THUMBNAILS);
                _rewardDetailsRespons = rewardDetailsResponse.offerDetails, img1 = _rewardDetailsRespons.img1, img2 = _rewardDetailsRespons.img2, img3 = _rewardDetailsRespons.img3, thumbnail = _rewardDetailsRespons.thumbnail, properties = _rewardDetailsRespons.properties, additionalData = _objectWithoutProperties(_rewardDetailsRespons, _excluded);
                propertyList = properties && Object.values(properties).map(function (item) {
                  return {
                    label: item.property_name,
                    value: item.property_id
                  };
                });
                setOfferDetail(_objectSpread({
                  img1: "".concat(rewardCenterBaseUrl).concat(img1),
                  img2: "".concat(rewardCenterBaseUrl).concat(img2),
                  img3: "".concat(rewardCenterBaseUrl).concat(img3),
                  thumbnail: "".concat(thumbnailUrls).concat(thumbnail),
                  hasData: true,
                  propertyList: propertyList
                }, additionalData));
                this.setState({
                  isLoading: false
                });
                _context4.next = 16;
                break;

              case 15:
                throw new Error(rewardDetailsResponse.error);

              case 16:
                _context4.next = 21;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t0 = _context4["catch"](1);
                console.error(_context4.t0);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 18]]);
      }));

      function _getRewardDetails() {
        return _getRewardDetails2.apply(this, arguments);
      }

      return _getRewardDetails;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          render = _this$props3.render,
          detail = _this$props3.detail;
      var _this$state = this.state,
          purchaseResponse = _this$state.purchaseResponse,
          purchaseDisabled = _this$state.purchaseDisabled,
          isLoading = _this$state.isLoading,
          showKycPopUp = _this$state.showKycPopUp;
      detail.pointsneeded = format(detail.pointsneeded);
      var terms = detail.terms;
      var termsByRegex = terms && terms.split(REG_EXP.https);

      var _ref2 = termsByRegex || [],
          _ref3 = _slicedToArray(_ref2, 2),
          termsText = _ref3[0],
          termsUrl = _ref3[1];

      return render(_objectSpread(_objectSpread({
        purchaseType: store.getState().prePurchase.purchaseType,
        onPurchase: this.onPurchase,
        onDismissPurchaseResponse: this.onDismissPurchaseResponse,
        purchaseResponse: purchaseResponse,
        defaultOfferThumbnail: "".concat(CdnPath.REWARD_CENTER_OFFERS_UI, "default_reward_tile.jpg"),
        purchaseDisabled: purchaseDisabled,
        isLoading: isLoading,
        showKycPopUp: showKycPopUp,
        onKycCheck: this.onKycCheck,
        hideKycPopUp: this.hideKycPopUp,
        onDisabledButtonClick: this.disabledButtonClick
      }, detail), {}, {
        termsText: termsText,
        termsUrl: termsUrl
      }));
    }
  }]);

  return OfferDetail;
}(Component);

OfferDetail.propTypes = {
  render: PropTypes.func.isRequired,
  detail: PropTypes.isRequired,
  activeOffer: PropTypes.isRequired,
  setOfferDetail: PropTypes.func.isRequired,
  casinoIdStatus: PropTypes.string.isRequired,
  casinoId: PropTypes.string.isRequired
};
export default connect(function (state) {
  return _objectSpread({
    detail: state.rewardCenter.api.offerDetails,
    // from detail API endpoint
    activeOffer: state.rewardCenter.api.core.offers.find(function (offer) {
      return offer.rid === state.rewardCenter.ux.activeOffer;
    }),
    // from core API endpoint
    hasData: state.rewardCenter.ux.offerDetails.hasData,
    memberLevel: state.playerInfo.memberLevel,
    kycResult: state.playerInfo.KYCResult,
    rewardCenterBaseUrl: state.rewardCenter.rewardCenterBaseUrl
  }, state.playerInfo);
}, function (dispatch) {
  return {
    setOfferDetail: function setOfferDetail(offerDetail) {
      dispatch(setOfferDetailAction(offerDetail));
    },
    onBackNavigation: function onBackNavigation() {
      dispatch(setRewardCenterCurrTab(RewardCenterTabs.OFFERS));
    },
    onPurchaseOffer: function onPurchaseOffer(offerId) {
      dispatch(RewardCenterInterface.purchaseOffer(offerId));
    }
  };
})(OfferDetail);